import { Component, Input } from '@angular/core';
import { GuideCardComponent } from '@shared/components/guide-card/guide-card.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { SelectDirective } from '@shared/components/input/select/select.directive';
import { KeyValue } from '@shared/interfaces/key-value/key-value';
import { enumToKeyValue } from '@app/core/utils/enum-to-key-value';
import {
  CreateMeteringPointCommand,
  DisconnectionType,
  ProductCharacteristicIdentification,
  ProductCharacteristicUnitType,
  UpdateMeteringPointCommand
} from '@app/api/dmc';
import { InputDirective } from '@shared/components/input/input/input.directive';
import { FormGroupType } from '@app/core/utils/formgroup-type';
import { LabelDirective } from '@shared/components/input/label/label.directive';

@Component({
  selector: 'app-meteringpoint-form-installation',
  imports: [
    GuideCardComponent,
    TranslatePipe,
    InputGroupComponent,
    SelectDirective,
    ReactiveFormsModule,
    InputDirective,
    LabelDirective
  ],
  templateUrl: './meteringpoint-form-installation.component.html',
  styleUrl: './meteringpoint-form-installation.component.css'
})
export class MeteringpointFormInstallationComponent {
  @Input() public form!: FormGroupType<CreateMeteringPointCommand | UpdateMeteringPointCommand>;

  @Input() public fullWidth: boolean = true;

  /** Populated Lists **/
  public unitTypeList: KeyValue[] = enumToKeyValue(ProductCharacteristicUnitType, { omitKeys: ['NotSpecified'], prefixValue: 'enum.meteringpoint.unittype.'});
  public productList: KeyValue[] = enumToKeyValue(ProductCharacteristicIdentification, { omitKeys: ['NotSpecified'], prefixValue: 'enum.meteringpoint.productcharacteristic.'});
  public disconnectionTypeList: KeyValue[] = enumToKeyValue(DisconnectionType, { omitKeys: ['NotSpecified'], prefixValue: 'enum.meteringpoint.disconnectiontype.'});

}
